import supabase from './supabaseconnect';

export async function get_rma_details_api(rma_id) {

    var { error } = await supabase.auth.refreshSession();

    var { data, error } = await supabase.from('rma_return_part_list').select('*').eq('rma_id',rma_id).order('part_line_no');
    if (error) {
        var response_data = { "success": false, "msg": error.message }
        return (response_data);
    } else {
        var response_data = { "success": true, "msg": "RMA Details", "data": data }
        return (response_data);
    }
}
